import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
//import { GetIconByName } from "../../config/icon";
import { GetIcon } from "../../../config/icon";
import { Button } from "../..";
import { notification } from "antd";
//import { formatCurrency } from "../../utils";

/* property description goes here

  type= {text or password}
  placeholder = { string - isRequired }
  isConfig={true or false}
  icanName={string - isRequired}
  label={string - isRequired}
  size={sma or lg}
  value={string - isRequired}
  statusName={string - isRequired}
  smallProp={true or false}
  isCount={true or false}
  count={number}
  maxCount={number}
  isShowRequired={true or false}
  rightType={password , rightCount)}
*/

const InputItem = ({ data, onChange, onClickAdd, onClick, isLoading }) => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordLength, setPasswordLength] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [lowerCase, setLowerCase] = useState(false);
  const password = data.value;

  useEffect(() => {
    const numbers = /[0-9]/g;
    const upperCase = /[A-Z]/g;
    const lowerCase = /[a-z]/g;
    setPasswordLength(String(password).length >= 8 ? true : false);
    setHasNumber(numbers.test(password) ? true : false);
    setUpperCase(upperCase.test(password) ? true : false);
    setLowerCase(lowerCase.test(password) ? true : false);
  }, [password]);

  const [cursor, setCursor] = useState();
  const ref = useRef(null);

  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, data.value]);

  const handleChange = (e) => {
    setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const handleCopy = () => {
    const actualUrl = data.value;
    navigator.clipboard.writeText(actualUrl).then(() => {
      notification.success({ message: "Link copied to clipboard!" });
    });
  };

  // Password toggle handler
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const checkValidity = (value, rules) => {
    let isValid = true;
    if (rules.email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(String(value).toLowerCase()) && isValid;
    }

    if (rules.url) {
      const re =
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
      isValid = re.test(String(value).toLowerCase()) && isValid;
    }

    if (rules.number) {
      const re = /^[0-9\b]+$/;
      if (!re.test(value)) {
        isValid = false;
      }
    }

    return isValid;
  };

  let inputElement = null;
  inputElement = (
    <>
      <form autoComplete="off">
        <input
          className={`txt-wrapper ${data.size} 
           ${data.isCountryCode ? "leftPadding " : ""} ${
            data.validation?.required && data.touched && !data.value
              ? "validation-on"
              : ""
          } ${data.isOTP ? "otp " : ""}`}
          disabled={data.disabled}
          value={data.value}
          {...data.elementConfig}
          {...(data.isPassword && {
            ...(data.elementConfig.type = passwordShown ? "text" : "password"),
          })}
          onChange={onChange && handleChange}
        />
      </form>

      {data.isCountryCode && (
        <>
          <div className={`mtw__left-country-code`}>
            <>+94</>
          </div>
        </>
      )}
      {data.btnName && (
        <div className={"mtw__btn"}>
          <Button
            data={{
              btnName: data.btnName,
              buttonType: "secondary s-border",
              buttonSize: "md-x",
              isLoading: isLoading,
            }}
            onClick={onClickAdd}
          />
        </div>
      )}
      {data.btnCopy && (
        <div className={"mtw__btn copy"}>
          <Button
            data={{
              btnName: data.btnCopy,
              buttonType: "secondary",
              buttonSize: "md-x x",
              isLoading: isLoading,
            }}
            onClick={handleCopy}
          />
        </div>
      )}
    </>
  );
  return (
    <>
      <div className={`main-txt-wrapper ${data.mainLayerStyles} `}>
        {data.label && (
          <div className={"mtw_txt-lbl d-flex flex-row"}>
            <label className={"txt-label"}>
              {data.label} {data.isShowRequired ? <b>*</b> : ""}
              {data.isOptional && (
                <span className={" ml-1 txt-label optional"}>(Optional)</span>
              )}
            </label>
            {/* {GetIcon(data.lblIcon)} */}
          </div>
        )}

        {data.lableConfig && (
          <div className={`mtw__title d-flex flex-row justify-content-between`}>
            {data.lableConfig}
            {data.topConfigName && (
              <div className={"mtw__configName"}>{data.topConfigName}</div>
            )}
          </div>
        )}
        <>{inputElement}</>

        {/*---- error goes here -----*/}
        {data &&
          data.validation &&
          data.validation.required &&
          data.touched && (
            <>
              {/*---- filed is required -----*/}
              {data.validation.required && !data.value && (
                <div className="mtw__statusCode animate__animated animate__fadeIn">
                  You can't keep this as empty
                </div>
              )}

              {/*----  invalid data-----*/}
              {data.value && data.invalidReason && (
                <div className="mtw__statusCode animate__animated animate__fadeIn">
                  {data.invalidReason}
                </div>
              )}

              {/*----  invalid data-----*/}
              {data.value &&
                data.validation.email &&
                !checkValidity(data.value, data.validation) && (
                  <div className="mtw__statusCode animate__animated animate__fadeIn">
                    Invalid email.
                  </div>
                )}

              {/*----  invalid data-----*/}
              {data.touched && !data.isValid && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.85rem",
                  }}
                >
                  {data.invalidReason}
                </div>
              )}

              {/*----  invalid data-----*/}
              {data.value &&
                data.validation.url &&
                !checkValidity(data.value, data.validation) && (
                  <div className="mtw__statusCode animate__animated animate__fadeIn">
                    Invalid url.
                  </div>
                )}

              {/*----  invalid data-----*/}
              {data.value &&
                data.validation.mobile &&
                !checkValidity(data.value, data.validation) && (
                  <div
                    className="mtw__statusCode d-flex flex-column
                   animate__animated animate__fadeIn"
                  >
                    Enter your 9-digit mobile number. (No spaces or dashes.)
                  </div>
                )}

              {/*---- number is required -----*/}
              {data.value && data.validation.number && !data.isValid && (
                <div className="mtw__statusCode animate__animated animate__fadeIn">
                  This filed required only numbers.
                </div>
              )}
            </>
          )}
      </div>
    </>
  );
};
export default InputItem;
